<script>
  import { onMount } from "svelte";
  import { eventBus } from "../lib/eventBus";
  import OpportunitiesTable from "../components/opportunitiesTable.svelte";
  import SyncButtons from "../components/syncButtons.svelte";
  import OpportunityPopupEditor from "../components/opportunityPopupEditor.svelte";
  import OpportunityOptions from "../components/opportunityOptions.svelte";
  import PageContainer from "../components/shared/PageContainer.svelte";

  let el1;
  let refreshKey = 0;
  let showHeavyModules = false;
  let idleHandle;

  const mountOpportunityCount = async () => {
    const module = await import("App/Opportunities/count");
    const OpportunitiesCount = module.default;
    if (el1) {
      el1.innerHTML = "";
      new OpportunitiesCount({ target: el1 });
    }
  };

  const handleRefreshOpportunities = () => {
    mountOpportunityCount();
    refreshKey += 1;
  };

  const handleWindowRefreshOpportunities = () => {
    mountOpportunityCount();
    refreshKey += 1;
  };

  onMount(() => {
    mountOpportunityCount();
    eventBus.on("refresh-opportunities", handleRefreshOpportunities);
    window.addEventListener("refresh-opportunities", handleWindowRefreshOpportunities);

    const schedule = window.requestIdleCallback ?? ((callback) => window.setTimeout(callback, 120));
    idleHandle = schedule(() => { showHeavyModules = true; });

    return () => {
      eventBus.off?.("refresh-opportunities", handleRefreshOpportunities);
      window.removeEventListener("refresh-opportunities", handleWindowRefreshOpportunities);
      if (idleHandle) {
        if (window.cancelIdleCallback) window.cancelIdleCallback(idleHandle);
        else clearTimeout(idleHandle);
      }
    };
  });
</script>

<div class="min-h-screen bg-[#1b1e2f] text-white">
  <PageContainer fullWidth={true} className="px-4 py-5 sm:px-6 lg:px-8">
    <div class="grid w-full grid-cols-1 gap-5">
      <div class="min-w-0 text-center text-white">
        <div class="[&_*]:!text-white" bind:this={el1} />
      </div>
      <div class="min-w-0">
        <OpportunityPopupEditor />
      </div>
      {#if showHeavyModules}
        <div class="min-w-0">
          <SyncButtons />
        </div>
      {/if}
      {#if showHeavyModules}
        {#key refreshKey}
          <div class="min-w-0">
            <OpportunitiesTable />
          </div>
        {/key}
      {/if}
      {#if showHeavyModules}
        <div class="min-w-0">
          <OpportunityOptions />
        </div>
      {/if}
    </div>
  </PageContainer>
</div>
